<template>
  <v-card flat class="mt-1 grey lighten-4">
    <!-- Search reulsts filter -->
    <v-slide-y-transition>
      <v-card-title v-if="showGridFilter">
        <v-layout row wrap>
          <v-flex :sm12="ruleQuickView" :sm4="!ruleQuickView">
            <v-text-field append-icon="filter_list" :label="messages.label.RULES_FILTER" single-line hide-details
              clearable v-model="search" @input="value => filterRulesList(value)">
            </v-text-field>
          </v-flex>
          <v-flex sm8 class="text-xs-right" v-show="!ruleQuickView">
            <div class="mr-2 mt-3">
              <v-icon color="accent darken-2" class="pr-2" small>info</v-icon>
              <span v-html="messages.info.RULE_DETAILS"></span>
            </div>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-slide-y-transition>
    <!-- Search Results -->
    <v-card-text class="py-1">
      <v-data-table :headers="headers" :items="filteredRulesList" :pagination.sync="pagination"
        :total-items="totalItems" :loading="rulesLoading" :rows-per-page-items="rowsPerPagesArray">
        <!-- Items -->
        <template slot="items" slot-scope="props">
          <tr :active="!!selectedRule && selectedRule.id == props.item.id" @click="showQuickView(props.item)"
            class="pointer">
            <td class="text-xs-left">{{ props.item.title }}</td>
            <td class="text-xs-left" v-if="!ruleQuickView">{{ props.item.type.toString() }}</td>
            <td class="text-xs-left" v-if="!ruleQuickView">{{ props.item._enabled }}</td>
            <td class="text-xs-left" v-if="displayProvider()">{{ getOwnerName(props.item.ownerId) }}</td>
            <td class="text-xs-left" v-if="displayProvider()">{{ getProviderName(props.item.secondaryOwner) }}</td>
            <td class="text-xs-center" v-if="displayActionsCount()">{{ getRuleActionsCount(props.item.actions) }}</td>
            <td class="text-xs-center" v-if="displayConditionsCount()">{{ getRuleConditionsCount(props.item.conditions)
            }}</td>
            <td class="text-xs-center" v-if="displayRulesCount()">{{ getRulesCount(props.item.items) }}</td>
            <td class="text-xs-center" v-if="displayRuleSetsCount()">{{ getRuleSetsCount(props.item.items) }}</td>
            <td class="text-xs-left" v-if="!ruleQuickView">{{ props.item._updated }}</td>
            <td class="text-xs-left" v-if="!ruleQuickView">{{ props.item._added }}</td>
            <td @click.stop="stopProp" v-if="!ruleQuickView">
              <v-menu offset-y left :disabled="rulesLoading">
                <v-btn icon slot="activator">
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="showCopyRuleModal(props.item)">
                    <v-list-tile-title>{{ getCopyLabelInfo() }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="showOverrideRuleModal(props.item)">
                    <v-list-tile-title>{{ getOverrideLabelInfo() }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="showTestRuleModal(props.item)">
                    <v-list-tile-title>{{ messages.label.TEST }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="goToEditView(props.item)">
                    <v-list-tile-title>{{ messages.label.EDIT }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="showDeleteDialog(props.item)" class="error--text">
                    <v-list-tile-title>{{ messages.label.DELETE }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <!-- No Data -->
        <template slot="no-data">
          <v-alert :value="true" color="info" class="black--text" icon="info">
            <span v-if="!initiatedSearch">
              {{ messages.info.SELECT_SEARCH_CRITERIA }}
            </span>
            <span v-else>
              {{ messages.info.NO_SEARCH_RESULTS }}
            </span>
          </v-alert>
        </template>
        <!-- No Results -->
        <template slot="no-results">
          <v-alert :value="true" color="info" class="black--text" icon="info">
            {{ messages.info.NO_FILTER_RESULTS }}
          </v-alert>
        </template>
      </v-data-table>
      <!-- Dialogs -->
      <!-- Delete Rule/RuleSet/RuleCollection -->
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="subheading ttu">
            {{ messages.label.DELETE }} {{ getRuleGroupingTitle() }}
          </v-card-title>
          <v-card-text>
            <!-- Error Alert -->
            <v-flex xs12 v-if="deleteErrorAlert">
              <v-alert v-model="deleteErrorAlert" type="error">
                {{ deleteErrorMessage }}
              </v-alert>
            </v-flex>
            <p>{{ messages.info.DELETE_RULE_1 }} <b>{{ selectedRuleToDelete.title }}</b> ? </p>
            <p v-html="messages.info.DELETE_RULE_2"></p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-1 white--text" @click="cancelDelete">
              {{ messages.label.CANCEL }}
            </v-btn>
            <v-btn color="error" :disabled="deletingRule" :loading="deletingRule" @click="deleteRuleItem()">
              {{ messages.label.YES }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Rule Test Dialog -->
      <MetadataRuleTest v-model="ruleTestDialog" :rule-obj="ruleObjectToTest" />
      <!-- Rule Copy Dialog -->
      <MetadataRuleCopy v-model="ruleCopyDialog" :rule-obj="ruleObjectToCopy" />
      <!-- Rule Override Dialog -->
      <MetadataRuleOverride v-model="ruleOverrideDialog" :rule-obj="ruleObjectToOverride" />
      <!-- Snackbar -->
      <v-flex xs12>
        <v-snackbar :bottom="true" :timeout="snackbar.timeout" :color="snackbar.color" v-model="snackbar.show">
          {{ snackbar.message }}
          <v-btn flat color="primary" @click.native="snackbar.show = false">Ok</v-btn>
        </v-snackbar>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex"
import MetadataRulesService from "@/MetadataRules/MetadataRulesService"
import * as metadataRulesDataService from "@/MetadataRules/MetadataRulesDataService"
import MetadataRuleTest from "@/MetadataRules/MetadataRuleTest"
import AppService from "@/AppService"
import messages from "@/MetadataRules/messages.json"
import { SET_RULE_QUICK_VIEW } from "@/store/constants/mutation-types"
import { IS_POLARIS, MVATS_WEB_SERVICE_URL, RULE_MGMT_DATA_SERVICE_URL } from "@/store/constants/getter-types"
import MetadataRuleCopy from "@/MetadataRules/MetadataRuleCopy"
import MetadataRuleOverride from "@/MetadataRules/MetadataRuleOverride"

function initialData() {
  return {
    search: "",
    selectedRule: {},
    rulesLoading: false,
    initiatedSearch: false,
    ruleObjectToTest: {},
    ruleTestDialog: false,
    ruleCopyDialog: false,
    ruleObjectToCopy: {},
    ruleObjectToOverride: {},
    ruleOverrideDialog: false,
    pagination: {
      sortBy: "title",
      page: 1,
      rowsPerPage: 25,
      descending: false
    },
    snackbar: {
      show: false,
      timeout: 3000,
      color: "error",
      message: ""
    },
    totalItems: 0,
    rowsPerPagesArray: [25, 50, 75, 100],
    rulesQueryObject: {},
    filteredRulesList: [],
    rulesList: [],
    deleteDialog: false,
    deletingRule: false, // Used for Rule / Rule Set / Rule collection
    selectedRuleToDelete: {},
    deleteErrorAlert: false,
    deleteErrorMessage: ""
  }
}
export default {
  name: "MetadataRulesSearchResult",
  components: {
    MetadataRuleTest,
    MetadataRuleCopy,
    MetadataRuleOverride
  },
  data: function () {
    return initialData()
  },
  computed: {
    ...mapState("metadataRules", [
      "ruleQuickView"
    ]),
    ...mapState([
      "mpxParentAccount", "mpxSubAccounts", "providerGroups"
    ]),
    ...mapGetters([
      IS_POLARIS, MVATS_WEB_SERVICE_URL, RULE_MGMT_DATA_SERVICE_URL
    ]),
    showGridFilter() {
      return this.rulesLoading || this.rulesList.length > 0
    },
    /**
    * headers  - Construct array of objects to show table headers
    * @return {array}
    */
    headers() {
      return this.getTableHeaders()
    }
  },
  watch: {
    /**
     * Watch handler for pagination object
     */
    pagination: {
      handler(newVal, oldVal) {
        if (this.initiatedSearch && oldVal !== newVal) {
          this.searchRules()
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations("metadataRules", [
      SET_RULE_QUICK_VIEW
    ]),
    /**
     * reset
     */
    reset() {
      Object.assign(this.$data, initialData())
      this.SET_RULE_QUICK_VIEW(false)
    },
    /**
     * getTableHeaders - Construct table headers to be displayed
     * @returns {array}
     */
    getTableHeaders() {
      let headerToDisplay = []
      let commonHeaders = [{
        text: messages.label.TH_TITLE,
        sortable: true,
        align: "left",
        value: "title"
      },
      {
        text: messages.label.TH_TYPE,
        sortable: false,
        align: "left",
        value: "type"
      },
      {
        text: messages.label.TH_ENABLED,
        sortable: false,
        align: "left",
        value: "disabled"
      }]

      let dateAndActionHeaders = [{
        text: messages.label.TH_UPDATED,
        sortable: true,
        align: "left",
        value: "updated"
      }, {
        text: messages.label.TH_ADDED,
        sortable: true,
        align: "left",
        value: "added"
      }, {
        text: "",
        sortable: false
      }]

      if (this.ruleQuickView) { // Just title when quick view is visible
        headerToDisplay = [{
          text: messages.label.TH_TITLE,
          sortable: true,
          align: "left",
          value: "title"
        }]
      } else {
        headerToDisplay = commonHeaders
        // Provider
        if (this.displayProvider()) {
          headerToDisplay = headerToDisplay.concat([{
            text: messages.label.TH_OWNER,
            sortable: false,
            align: "left",
            value: "ownerId"
          }])
          headerToDisplay = headerToDisplay.concat([{
            text: messages.label.TH_PROVIDER,
            sortable: false,
            align: "left",
            value: "secondaryOwner"
          }])
        }
        // Rule / Rule Set / Rule Collection specific
        switch (this.rulesQueryObject.grouping) {
          case "rules":
            if (this.displayActionsCount()) {
              headerToDisplay = headerToDisplay.concat([{
                text: messages.label.TH_ACTIONS_COUNT,
                sortable: false,
                align: "left",
                value: "actions"
              }])
            }
            headerToDisplay = headerToDisplay.concat([{
              text: messages.label.TH_CONDITIONS_COUNT,
              sortable: false,
              align: "left",
              value: "conditions"
            }])
            break
          case "ruleSets":
            headerToDisplay = headerToDisplay.concat([{
              text: messages.label.TH_RULES_COUNT,
              sortable: false,
              align: "left",
              value: "rules"
            }])
            break
          case "ruleCollection":
            headerToDisplay = headerToDisplay.concat([{
              text: messages.label.TH_RULE_SET_COUNT,
              sortable: false,
              align: "left",
              value: "ruleSets"
            }])
            break
        }
        headerToDisplay = headerToDisplay.concat(dateAndActionHeaders)
      }
      return headerToDisplay
    },

    /**
     * filterRulesList - For filtering rules list with text value
     * @param {string} search
     */
    filterRulesList(search) {
      if (search) {
        search = search.toString().toLowerCase()
        const displayedKeys = [
          "title",
          "type",
          "_enabled",
          "_updated"
        ]
        this.filteredRulesList = this.rulesList.filter((obj) => {
          let filteredObj = this.$lodash.pick(obj, displayedKeys)
          return Object.keys(filteredObj).some(function (key) {
            if (filteredObj[key] !== null) {
              return filteredObj[key]
                .toString()
                .toLowerCase()
                .includes(search)
            }
          })
        })
      } else {
        this.filteredRulesList = this.rulesList
      }
    },

    /**
     * Get pagination params
     */
    getPageParams(pagination) {
      let startRange
      let endRange
      if (pagination.page === 1) {
        startRange = 1
        endRange = pagination.rowsPerPage
      } else {
        startRange = (pagination.page - 1) * pagination.rowsPerPage + 1
        endRange = startRange + pagination.rowsPerPage - 1
      }
      return startRange + "-" + endRange
    },

    /**
     * getSortParams - Construct sorting param
     *
     * @param  {object} pagination pagination object
     * @return {string}            ex: '<filedName>|desc'
     */
    getSortParams(pagination) {
      let sortParams = ""
      sortParams =
        !this.$lodash.isNull(pagination.sortBy) &&
          !this.$lodash.isEmpty(pagination.sortBy)
          ? pagination.sortBy
          : "title"
      if (pagination.descending) {
        sortParams += "|desc"
      }
      return sortParams
    },

    /**
     * initiateRulesSearch
     * @param {object} searchParams
     */
    initiateRulesSearch(searchParams) {
      this.initiatedSearch = true
      this.SET_RULE_QUICK_VIEW(false)
      this.selectedRule = {}
      this.rulesQueryObject = searchParams
      this.searchRules()
    },

    /**
     * searchRules - retrieves rules / rule sets / rule collection based on grouping selected
     * @return {array}
     */
    searchRules() {
      this.rulesLoading = true
      this.rulesList = []
      let queryObject = this.$lodash.cloneDeep(this.rulesQueryObject)
      // Omit 'grouping' as they are client only
      queryObject = this.$lodash.omit(queryObject, ["grouping"])
      queryObject.range = this.getPageParams(this.pagination)
      queryObject.sort = this.getSortParams(this.pagination)
      queryObject.count = true
      let searchPromise = {}
      switch (this.rulesQueryObject.grouping) {
        case "rules":
          searchPromise = this.retrieveRules(queryObject)
          break
        case "ruleSets":
          searchPromise = this.retrieveRuleSets(queryObject)
          break
        case "ruleCollection":
          searchPromise = this.retrieveRuleCollections(queryObject)
          break
      }

      return searchPromise
        .then((response) => {
          this.rulesList = MetadataRulesService.addClientOnlyFields(response.data.entries)
          this.filterRulesList(this.search)
          this.totalItems = response.data.totalResults
          return response
        }).catch((error) => {
          // TODO: handle error
          this.rulesList = []
          this.filteredRulesList = []
          this.totalItems = 0
          return Promise.reject(error)
        }).finally(() => {
          this.rulesLoading = false
        })
    },

    /**
     * retrieveRules - Retrieve rules list
     * @param {object} queryObject
     * @returns {Promise}
     */
    retrieveRules(queryObject) {
      return metadataRulesDataService
        .getRule(queryObject,
          this.RULE_MGMT_DATA_SERVICE_URL)
        .then((response) => {
          return response
        }).catch((error) => {
          return Promise.reject(error)
        })
    },

    /**
     * retrieveRuleSets - Retrieve rule sets
     * @param {object} queryObject
     * @returns {Promise}
     */
    retrieveRuleSets(queryObject) {
      return metadataRulesDataService
        .getRuleSet(queryObject,
          this.RULE_MGMT_DATA_SERVICE_URL)
        .then((response) => {
          return response
        }).catch((error) => {
          return Promise.reject(error)
        })
    },

    /**
     * retrieveRuleCollections - Retrieve rule collection
     * @param {object} queryObject
     * @returns {Promise}
     */
    retrieveRuleCollections(queryObject) {
      return metadataRulesDataService
        .getRuleCollection(queryObject,
          this.RULE_MGMT_DATA_SERVICE_URL)
        .then((response) => {
          return response
        }).catch((error) => {
          return Promise.reject(error)
        })
    },

    /**
     * showDeleteDialog -
     */
    showDeleteDialog(rule) {
      this.selectedRuleToDelete = rule
      this.deleteDialog = true
    },

    /**
     * cancelDelete - close delete dialog
     */
    cancelDelete() {
      this.selectedRuleToDelete = {}
      this.deleteErrorAlert = false
      this.deleteErrorMessage = ""
      this.deleteDialog = false
    },

    /**
     * deleteRuleItem - Delete selected rule / ruleset / rule collection
     */
    deleteRuleItem() {
      this.deletingRule = true
      let id = this.selectedRuleToDelete.id.split("/").pop()
      let deletePromise = {}
      switch (this.rulesQueryObject.grouping) {
        case "rules":
          deletePromise = this.deleteRule(id)
          break
        case "ruleSets":
          deletePromise = this.deleteRuleSet(id)
          break
        case "ruleCollection":
          deletePromise = this.deleteRuleCollection(id)
          break
      }

      deletePromise
        .then(() => {
          this.selectedRuleToDelete = {}
          this.deleteDialog = false
          // Show Snackbar
          this.snackbar.show = true
          this.snackbar.color = "success"
          this.snackbar.message = this.messages.info.DELETE_SUCCESS + this.getRuleGroupingTitle()
          // Update search result
          this.searchRules()
        }).catch((error) => {
          let response = error.response.data
          if (response.isException) {
            this.deleteErrorAlert = true
            this.deleteErrorMessage = response.description
          }
        }).finally(() => {
          this.deletingRule = false
        })
    },

    /**
    * deleteRule - Delete rule
    * @param {object} queryObject
    * @returns {Promise}
    */
    deleteRule(ruleId) {
      return metadataRulesDataService
        .deleteRule(ruleId,
          this.RULE_MGMT_DATA_SERVICE_URL)
        .then((response) => {
          return response
        }).catch((error) => {
          return Promise.reject(error)
        })
    },

    /**
     * deleteRuleSet - Delete rule set
     * @param {object} queryObject
     * @returns {Promise}
     */
    deleteRuleSet(ruleSetId) {
      return metadataRulesDataService
        .deleteRuleSet(ruleSetId,
          this.RULE_MGMT_DATA_SERVICE_URL)
        .then((response) => {
          return response
        }).catch((error) => {
          return Promise.reject(error)
        })
    },

    /**
     * deleteRuleCollection - Delete rule collection
     * @param {object} queryObject
     * @returns {Promise}
     */
    deleteRuleCollection(ruleCollectionId) {
      return metadataRulesDataService
        .deleteRuleCollection(ruleCollectionId,
          this.RULE_MGMT_DATA_SERVICE_URL)
        .then((response) => {
          return response
        }).catch((error) => {
          return Promise.reject(error)
        })
    },

    /**
     * displayConditionsCount  - identify if conditions count column needs to be displayed
     * @returns {boolean}
     */
    displayConditionsCount() {
      const grouping = this.rulesQueryObject.grouping
      let display = false
      if (!this.ruleQuickView && grouping === "rules") {
        display = true
      }
      return display
    },

    /**
     * displayActionsCount  - identify if actions count column needs to be displayed
     * @returns {boolean}
     */
    displayActionsCount() {
      const grouping = this.rulesQueryObject.grouping
      let display = false
      if (!this.ruleQuickView &&
        grouping === "rules" &&
        (this.$lodash.isUndefined(this.rulesQueryObject.byType) ||
          this.rulesQueryObject.byType === "TRANSFORMATION")) {
        display = true
      }
      return display
    },

    /**
    * displayRulesCount  - identifying conditions for displaying the rulesCount column
    * @returns {boolean}
    */
    displayRulesCount() {
      const grouping = this.rulesQueryObject.grouping
      let display = false
      if (!this.ruleQuickView && (grouping === "ruleSets")) {
        display = true
      }
      return display
    },

    /**
     * displayRuleSetsCount  - identifying conditions for displaying the ruleSetsCount column
     * @returns {boolean}
     */
    displayRuleSetsCount() {
      const grouping = this.rulesQueryObject.grouping
      let display = false
      if (!this.ruleQuickView && grouping === "ruleCollection") {
        display = true
      }
      return display
    },

    /**
     * displayProvider  - identify if provider needs to be displayed
     * @returns {boolean}
     */
    displayProvider() {
      const account = this.rulesQueryObject.account
      let display = false
      if (!this.ruleQuickView && account !== this.mpxParentAccount.id) {
        display = true
      }
      return display
    },

    /**
     * getRuleConditionsCount - return count of conditions exists in a rule
     * @param {array} conditionsArray
     * @returns {number}
     */
    getRuleConditionsCount(conditionsArray) {
      if (!this.$lodash.isUndefined(conditionsArray)) {
        return conditionsArray.length
      } else {
        return 0
      }
    },

    /**
     * getRuleActionsCount - return count of actions exists in a rule
     * @param {array} actionsArray
     * @returns {number}
     */
    getRuleActionsCount(actionsArray) {
      if (!this.$lodash.isUndefined(actionsArray)) {
        return actionsArray.length
      } else {
        return 0
      }
    },

    /**
     *  getRuleSetsCount - return count of rule sets exists in a rule collection
     * @param {array} itemsArray
     */
    getRuleSetsCount(itemsArray) {
      if (!this.$lodash.isUndefined(itemsArray)) {
        return itemsArray.length
      } else {
        return 0
      }
    },

    /**
     *  getRulesCount - return count of rules exists in a rule set or in a rule collections
     * @param {array} itemsArray
     */
    getRulesCount(itemsArray) {
      if (!this.$lodash.isUndefined(itemsArray)) {
        return itemsArray.length
      } else {
        return 0
      }
    },

    /**
     * showQuickView - Show selected rule details
     * @param {object} selectedRule
     */
    showQuickView(selectedRule) {
      this.selectedRule = selectedRule
      this.SET_RULE_QUICK_VIEW(true)
      this.dispatchShowQuickViewEvent(selectedRule)
    },

    /**
     * dispatchShowQuickViewEvent
     * @param {object} rule
     */
    dispatchShowQuickViewEvent(rule) {
      // NOTE: param 'rule' can be a rule / rule set / rulecollection object
      switch (this.rulesQueryObject.grouping) {
        case "rules":
          MetadataRulesService.$emit("event:showRuleQuickView", rule)
          break
        case "ruleSets":
          MetadataRulesService.$emit("event:showRuleSetQuickView", rule)
          break
        case "ruleCollection":
          MetadataRulesService.$emit("event:showRuleCollectionQuickView", rule)
          break
      }
    },

    /**
     * getCopyLabelInfo - for displayig Copy Label for rule / rule set & rule collection
     */
    getCopyLabelInfo() {
      let copyLabel = ""
      switch (this.rulesQueryObject.grouping) {
        case "rules":
          copyLabel = this.messages.label.COPY_RULE
          break
        case "ruleSets":
          copyLabel = this.messages.label.COPY_RULE_SET
          break
        case "ruleCollection":
          copyLabel = this.messages.label.COPY_RULE_COLLECTION
          break
      }
      return copyLabel
    },

    /**
     * getOverrideLabelInfo - for displayig Override Label for rule / rule set & rule collection
     */
    getOverrideLabelInfo() {
      let overrideLabel = ""
      switch (this.rulesQueryObject.grouping) {
        case "rules":
          overrideLabel = this.messages.label.OVERRIDE_RULE
          break
        case "ruleSets":
          overrideLabel = this.messages.label.OVERRIDE_RULE_SET
          break
        case "ruleCollection":
          overrideLabel = this.messages.label.OVERRIDE_RULE_COLLECTION
          break
      }
      return overrideLabel
    },

    /**
     * hideQuickView
     */
    hideQuickView() {
      this.selectedRule = {}
      this.SET_RULE_QUICK_VIEW(false)
    },

    /**
     * refreshSearchResults - Update search result and re-populate the quick view
     */
    refreshSearchResults() {
      this.searchRules().then(() => {
        this.selectedRule = this.$lodash.find(this.filteredRulesList, (item) => {
          return item.id === this.selectedRule.id
        })
        if (!this.$lodash.isUndefined(this.selectedRule)) {
          this.dispatchShowQuickViewEvent(this.selectedRule)
        } else {
          this.hideQuickView()
        }
      })
    },

    /**
     * stopProp - Do nothing, just to stop event propogation
     */
    stopProp() { },

    /**
     * goToEditView - Navigate to Edit view
     */
    goToEditView(item) {
      const grouping = this.rulesQueryObject.grouping
      let id = item.id.split("/").pop()
      let ownerId = item.ownerId
      switch (grouping) {
        case "rules":
          this.$router.push({ name: "ManageRule", params: { id: id }, query: { account: ownerId } })
          break
        case "ruleSets":
          this.$router.push({ name: "ManageRuleSet", params: { id: id }, query: { account: ownerId } })
          break
        case "ruleCollection":
          this.$router.push({ name: "ManageRuleCollection", params: { id: id }, query: { account: ownerId } })
          break
      }
    },

    /**
     * getRuleGroupingTitle - returns rule / ruleset / rule collection based on
     * selected grouping
     * @returns {string}
     */
    getRuleGroupingTitle() {
      const grouping = this.rulesQueryObject.grouping
      let groupingTitle = ""
      switch (grouping) {
        case "rules":
          groupingTitle = this.messages.label.RULE
          break
        case "ruleSets":
          groupingTitle = this.messages.label.RULE_SET
          break
        case "ruleCollection":
          groupingTitle = this.messages.label.RULE_COLLECTION
          break
      }
      return groupingTitle
    },

    /**
     * showTestRuleModal
     * @param {object} ruleObj - Can be rule / ruleset / rule collection
     */
    showTestRuleModal(ruleObj) {
      this.ruleObjectToTest = ruleObj
      this.ruleTestDialog = true
    },

    /**
     * showCopyRuleModal
     * @param {object} ruleObj - Can be rule / ruleset / rule collection
     */
    showCopyRuleModal(ruleObj) {
      this.ruleObjectToCopy = ruleObj
      this.ruleCopyDialog = true
    },

    /**
     * showOverrideRuleModal
     * @param {object} ruleObj - Can be rule / ruleset / rule collection
     */
    showOverrideRuleModal(ruleObj) {
      this.ruleObjectToOverride = ruleObj
      this.ruleOverrideDialog = true
    },

    /**
     * getProviderName
     * @param {stirng} secondaryOwner
     */
    getProviderName(secondaryOwner) {
      return MetadataRulesService.getProviderName(secondaryOwner)
    },

    /**
     * getOwnerName
     * @param {stirng} ownerId
     */
    getOwnerName(ownerId) {
      if (this.IS_POLARIS) {
        return MetadataRulesService.getOwnerName(ownerId, this.mpxParentAccount.id, this.providerGroups, true)
      } else {
        return MetadataRulesService.getOwnerName(ownerId, this.mpxParentAccount.id, this.mpxSubAccounts, false)
      }
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Events
     */
    MetadataRulesService.$on("event:searchMetadataRules", this.initiateRulesSearch)
    MetadataRulesService.$on("event:refreshRulesList", this.refreshSearchResults)
    MetadataRulesService.$on("event:hideRuleQuickView", this.hideQuickView)
    MetadataRulesService.$on("event:hideRuleSetQuickView", this.hideQuickView)
    MetadataRulesService.$on("event:hideRuleCollectionQuickView", this.hideQuickView)
    AppService.$on("event:mpxAccountChanged", this.reset)
  },
  beforeDestroy() {
    MetadataRulesService.$off("event:searchMetadataRules", this.initiateRulesSearch)
    MetadataRulesService.$off("event:refreshRulesList", this.refreshSearchResults)
    MetadataRulesService.$off("event:hideRuleQuickView", this.hideQuickView)
    MetadataRulesService.$off("event:hideRuleSetQuickView", this.hideQuickView)
    MetadataRulesService.$off("event:hideRuleCollectionQuickView", this.hideQuickView)
    AppService.$off("event:mpxAccountChanged", this.reset)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/MetadataRules/MetadataRulesSearchResult.vue